import {$t} from "@/i18n";

export const APP_STORE_BUNDLE_IDS = {
    TRIAL: 1,
    SOLO: 4,
    TEAM: 5,
    ENTERPRISE: 6,
}

export const APP_STORE_BUNDLE_TYPES = {
    TRIAL: "trial",
    SOLO: "solo",
    TEAM: "team",
    ENTERPRISE: "enterprise",
}

export const APP_STORE_APP_TYPES = {
    MINI_UKU: "mini_uku",
    TASKS: "tasks",
    CLIENTS: "clients",
    AML: "aml",
    SMART_ACCOUNTS: "smart_accounts",
    MERIT_AKTIVA: "merit_aktiva",
    BILLING: "billing",
    MONITORING: "monitoring",
    SCORO: "scoro",
    MAGIC_BUTTON: "magic_button",
    SUPPLIER: "supplier",
    CLIENT_PORTAL: "client_portal",
    CHAT: "chat",
    PROJECT: "project",
    EMAILING: "emailing",
    ECONOMIC: "economic",
    COMPANY: "company",
    FLEXTIME: "flextime",
    XERO: "xero",
    QUICKBOOKS: "quickbooks",
    TRIPLETEX: "tripletex",
    FORTNOX: "fortnox",
    COMPANIES_HOUSE: "companies_house",
    DOCUMENTS: "documents", // 28
    FREEAGENT: "freeagent", // 29
    TRIGON: "trigon", // 30
    CLIENT_PORTAL_MENU: "client_portal_menu", // 31
}

export const APP_STORE_APP_IDS = {
    BILLING: 1,
    MONITORING: 2,
    MERIT_AKTIVA: 3,
    SMART_ACCOUNTS: 4,
    SCORO: 5,
    AML: 6,
    CLIENT_PORTAL: 7,
    MAGIC_BUTTON: 9,
    SUPPLIER: 10,
    PROJECT: 11,
    EMAILING: 12,
    ECONOMIC: 13,
    FLEXTIME: 14,
    XERO: 15,
    CHAT: 16,
    TASKS: 23,
    COMPANY: 20,
    CLIENTS: 21,
    COMPANIES_HOUSE: 24,
    QUICKBOOKS: 25,
    TRIPLETEX: 26,
    FORTNOX: 27,
    DOCUMENTS: 28,
    FREEAGENT: 29,
    TRIGON: 30
}

export const MERIT_IMPORTS = {
    EASY_IMPORT: 1,
    UKU_ONLY_IMPORT: 0,
}

export const IMPORT_SESSION_STATUSES = {
    NEW: "new",
    UPLOADED: "uploaded",
    UPLOADING: "uploading",
    IMPORTED: "imported",
    IMPORTING: "importing",
}

export const INVOICE_DAYS = () => [
    {text: $t("Last day of the month"), value: -1},
    {text: $t("Creation date"), value: 0},
    {text: "1", value: 1},
    {text: "2", value: 2},
    {text: "3", value: 3},
    {text: "4", value: 4},
    {text: "5", value: 5},
    {text: "6", value: 6},
    {text: "7", value: 7},
    {text: "8", value: 8},
    {text: "9", value: 9},
    {text: "10", value: 10},
    {text: "11", value: 11},
    {text: "12", value: 12},
    {text: "13", value: 13},
    {text: "14", value: 14},
    {text: "15", value: 15},
    {text: "16", value: 16},
    {text: "17", value: 17},
    {text: "18", value: 18},
    {text: "19", value: 19},
    {text: "20", value: 20},
    {text: "21", value: 21},
    {text: "22", value: 22},
    {text: "23", value: 23},
    {text: "24", value: 24},
    {text: "25", value: 25},
    {text: "26", value: 26},
    {text: "27", value: 27},
    {text: "28", value: 28},
];

export const INVOICE_PERIODS = () => [
    {text: $t("Monthly"), value: "monthly"},
    {text: $t("Quarterly"), value: "quarterly"},
    {text: $t("Yearly"), value: "yearly"}
];

export const CONTRACT_STATUSES = [
    {code: "active", name: $t("Active")},
    {code: "inactive", name: $t("Inactive")}
];

export const CONTRACT_TYPES = {
    TEMPLATE: "template",
    CONTRACT: "contract"
}

export const PRODUCT_FIELD_TYPES = {
    ARTICLE: 'article',
    RESOURCE: 'resource',
    BILLING_PROJECT: 'billing_project',
    UNIT: 'unit',
    BANK_ACCOUNT: 'bank_account',
}

export const CONTENT_TEMPLATE_TYPE = {
    EMAIL_AUTOMATION: 'email_automation',
    INVOICE: 'invoice'
}

export const CONTENT_TEMPLATE_CHANNEL = {
    EMAIL: 'email',
    PDF: 'pdf',
    EMAIL_AUTOMATION: 'email_automation'
}

export const QUOTE_HEADERS_REGEX = [
    /^Kontakt\s[\S\s]+\(&lt;[\w.-]+@[\w.-]+&gt;\)\skirjutas\skuupäeval\s[ETNKRP],\s\d{1,2}\.\s(?:jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/m,
    /^(?:&gt;)*\s*(?:Kontakt\s[\S\s]+\skirjutas\skuupäeval\s)?[ETNKRP],\s\d{1,2}\.\s(?:jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)\n\d{4}\skell\s\d{1,2}:\d{2}\s.+\skirjutas:$/m,
    /^[ETNKRP],\s\d{1,2}\.\s(?:jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)\s\d{4}\s\d{1,2}:\d{2}\s.+\skirjutas:$/,
    /^(?:&gt;)*\s*(On(?:(?!.*On\b|\bwrote:)[\s\S])+wrote:)$/m, // On DATE, NAME <EMAIL> wrote:
    /^(?:&gt;)*\s*(Le(?:(?!.*Le\b|\bécrit:)[\s\S])+écrit(\s|\xc2\xa0):)$/m, // On DATE, NAME <EMAIL> wrote:
    /^(?:&gt;)*\s*(El(?:(?!.*El\b|\bescribió:)[\s\S])+escribi(ó|eron):)$/m, // On DATE, NAME <EMAIL> wrote:
    /^(?:&gt;)*\s*(Il(?:(?!.*Il\b|\bscritto:)[\s\S])+scritto:)$/m, // On DATE, NAME <EMAIL> wrote:
    /^(?:&gt;)*\s*(Op\s[\S\s]+?(schreef|geschreven)[\S\s]+:)$/m, // Op DATE schreef NAME <EMAIL>:, Op DATE heeft NAME <EMAIL> het volgende geschreven:
    /^(?:&gt;)*\s*(Em(?:(?!.*Em\b|\bescreveu:)[\s\S])+escreveu:)$/m, // Em DATE, NAME <EMAIL> escreveu:
    /^(?:&gt;)*\s*((W\sdniu|Dnia)\s[\S\s]+?(pisze|napisał(\(a\))?):)$/mu, // W dniu DATE, NAME <EMAIL> pisze|napisał:
    /^(?:&gt;)*\s*(Den\s.+\sskrev\s.+:)$/m, // Den DATE skrev NAME <EMAIL>:
    /^(?:&gt;)*\s*(Am\s.+\sum\s.+\sschrieb\s.+:)$/m, // Am DATE um TIME schrieb NAME:
    /^(在[\S\s]+写道：)$/m, // > 在 DATE, TIME, NAME 写道：
    /^(20[0-9]{2}\..+\s작성:)$/m, // DATE TIME NAME 작성:
    /^(20[0-9]{2}\/.+のメッセージ:)$/m, // DATE TIME、NAME のメッセージ:
    /^(.+\s<.+>\sschrieb:)$/m, // NAME <EMAIL> schrieb:
    /^(?:&gt;)*\s*(From\s?:.+\s?(\[|<).+(\]|>))/mu, // "From: NAME <EMAIL>" OR "From : NAME <EMAIL>" OR "From : NAME<EMAIL>"(With support whitespace before start and before <)
    /^(?:&gt;)*\s*(De\s?:.+\s?(\[|<).+(\]|>))/mu, // "De: NAME <EMAIL>" OR "De : NAME <EMAIL>" OR "De : NAME<EMAIL>"  (With support whitespace before start and before <)
    /^(?:&gt;)*\s*(Van\s?:.+\s?(\[|<).+(\]|>))/mu, // "Van: NAME <EMAIL>" OR "Van : NAME <EMAIL>" OR "Van : NAME<EMAIL>"  (With support whitespace before start and before <)
    /^(?:&gt;)*\s*(Da\s?:.+\s?(\[|<).+(\]|>))/mu, // "Da: NAME <EMAIL>" OR "Da : NAME <EMAIL>" OR "Da : NAME<EMAIL>"  (With support whitespace before start and before <)
    /^(20[0-9]{2}-(?:0?[1-9]|1[012])-(?:0?[0-9]|[1-2][0-9]|3[01]|[1-9])\s[0-2]?[0-9]:\d{2}\s[\S\s]+?:)$/m, // 20YY-MM-DD HH:II GMT+01:00 NAME <EMAIL>:
    /^(?:&gt;)*\s*([a-z]{3,4}\.[\s\S]+\sskrev[\s\S]+:)$/m, // DATE skrev NAME <EMAIL>:
    /^(?:&gt;)*\s*(El(?:(?!^>*\s*El\b|\bha escrit:).){0,1000}ha escrit:)$/ms, // El DATE, NAME <EMAIL> ha escrit:
];

export const SIGNATURE_REGEX = /(?:^\s*--|^\s*__|^-\w|^-- $)|(?:^Sent from my (?:\s*\w+){1,4}$)|(?:^={30,}$)$/;

export const QUOTE_REGEX = /(&gt;)+/;

export const TASK_LOG_TYPE = {
    TASK_COMMENT: 'comment', // task_log.action IS "comment"
    TASK_MESSAGE: 'message',
    TASK_MESSAGE_FROM_EMAIL: 'message_from_email',
    TASK_INCOMING_EMAIL: 'incoming_email',
    TASK_CREATED: 'task_created',
    TASK_CREATED_EMAIL: 'task_created_email',
    TASK_CREATED_SUMMARY_EMAIL: 'task_created_summary_email',
    TASK_CREATED_CLIENT_EMAIL: 'task_created_client_email',
    TASK_CREATED_PROJECT_EMAIL: 'task_created_project_email',
    TASK_MESSAGE_FROM_CLIENT_EMAIL: 'task_message_from_client_email',
    TASK_MESSAGE_FROM_PROJECT_EMAIL: 'task_message_from_project_email',
    REQUEST_CREATED: 'request_created',
    TASK_UPDATED: 'task_updated',
    TASK_IN_PROGRESS: 'task_in_progress',
    TASK_AUTO_FINISH_FAILED: 'task_auto_finish_failed',
    TASK_FINISHED: 'task_finished',
    TASK_DELEGATED: 'task_delegated',
    TASK_ASSIGNED: 'task_assigned',
    TASK_ASSIGNED_CP: 'task_assigned_cp',
    TASK_REMINDER: 'task_reminder',
    TASK_DELETED: 'task_deleted',
    TASK_CHANGE_IS_CP: 'task_change_is_cp',
    TASK_CLOSED: 'task_closed',
    TASK_OPENED: 'task_opened',
    TASK_ATTACHMENT_ADDED: 'task_attachment_added',
    TASK_COMMENT_ADDED: 'task_comment',
    TASK_MESSAGE_ADDED: 'task_message',
    TASK_MESSAGE_FROM_TASK_EMAIL_ADDED: 'task_message_from_task_email',
    TASK_NOTE_UPDATED: 'task_note_updated',
    TASK_CHECKLIST_UPDATED: 'task_checklist_updated',

    TASK_TEMPLATE_CREATED: 'task_template_created',
    TASK_TEMPLATE_UPDATED: 'task_template_updated',
    TASK_TEMPLATE_ASSIGNED: 'task_template_assigned',
    TASK_TEMPLATE_DELETED: 'task_template_deleted',

    TASK_EMAIL_ADDED: 'task_email_added',
    TASK_EMAIL_CHANGED: 'task_email_changed',
    TASK_EMAIL_DELETED: 'task_email_deleted',
    TASK_EMAIL_SEND_SUCCESS: 'task_email_send_success',
    TASK_EMAIL_SEND_FAILED: 'task_email_send_failed',

    CLIENT_CREATED: 'client_created',
    CLIENT_UPDATED: 'client_updated',
    CLIENT_ASSIGNED: 'client_assigned',
    CLIENT_DEACTIVATED: 'client_deactivated',
    CLIENT_DELETED: 'client_deleted',

    LOGIN: 'login',
    ACCOUNT_CREATED: 'account_created',
    INVITATION_ACCEPTED: 'invitation_accepted',
    COMPANY_ACCOUNT_DELETED: 'company_account_deleted',
}

export const PUBLIC_MESSAGE_TYPES = [
    TASK_LOG_TYPE.TASK_MESSAGE_ADDED,
    TASK_LOG_TYPE.TASK_MESSAGE_FROM_EMAIL,
    TASK_LOG_TYPE.TASK_CREATED_CLIENT_EMAIL,
    TASK_LOG_TYPE.TASK_CREATED_EMAIL,
    TASK_LOG_TYPE.TASK_CREATED_PROJECT_EMAIL,
    TASK_LOG_TYPE.TASK_MESSAGE_FROM_TASK_EMAIL_ADDED
]

export const COMMUNICATION_TASK_LOG_TYPES = [
    TASK_LOG_TYPE.TASK_MESSAGE_FROM_EMAIL,
    TASK_LOG_TYPE.TASK_INCOMING_EMAIL,
    TASK_LOG_TYPE.TASK_MESSAGE_FROM_CLIENT_EMAIL,
    TASK_LOG_TYPE.TASK_MESSAGE_FROM_PROJECT_EMAIL
]

export const TASK_AUTOMATION_DAYS = () => {
    const options = [
        {
            text: $t('{0} days after').format(3),
            days: 3
        },
        {
            text: $t('{0} days after').format(2),
            days: 2
        },
        {
            text: $t('{0} day after').format(1),
            days: 1
        },
        {
            text: $t('right away when'),
            days: 0
        },
        {
            text: $t('{0} day before').format(1),
            days: -1
        }
    ]

    for (let i = 2; i < 31; i++) {
        options.push({
            text: $t('{0} days before').format(i),
            days: i * -1
        })
    }

    return options
}

export const TASK_AUTOMATION_STATUS = {
    NEW: 'new'
}

export const TASK_AUTOMATION_TRIGGER_TYPE = {
    START_DATE: 'start_date',
    DUE_DATE: 'due_date',
    FINISHED: 'finished'
}

export const TASK_AUTOMATION_TRIGGERS = () => [
    {
        text: $t('start date'),
        type: TASK_AUTOMATION_TRIGGER_TYPE.START_DATE
    },
    {
        text: $t('due date'),
        type: TASK_AUTOMATION_TRIGGER_TYPE.DUE_DATE
    },
    {
        text: $t('finished'),
        type: TASK_AUTOMATION_TRIGGER_TYPE.FINISHED
    },
]

export const CUSTOM_FIELD_RELATED_TYPE = {
    TASK: 'task',
    CLIENT: 'client',
    PROJECT: 'project'
}

export const INTEGRATION_DATA_FIELDS = [
    {
        title: $t('Entries count'),
        value: 'entries'
    },
    {
        title: $t('Entries excluding sales'),
        value: 'entries_minus_sale'
    },
    {
        title: $t('Entries excluding bank'),
        value: 'entries_minus_bank'
    },
    {
        title: $t('Entries excluding documents'),
        value: 'entries_minus_documents'
    },
    {
        title: $t('Documents (sales and purchases)'),
        value: 'documents'
    },
    {
        title: $t('Cash entries'),
        value: 'cash_entries'
    },
    {
        title: $t('VAT entries'),
        value: 'vat_entries'
    },
    {
        title: $t('Stock entries'),
        value: 'stock_entries'
    },
    {
        title: $t('Sale entries'),
        value: 'sale_entries'
    },
    {
        title: $t('Purchase entries'),
        value: 'purchase_entries'
    },
    {
        title: $t('Bank entries'),
        value: 'bank_entries'
    },
    {
        title: $t('Ledger entries'),
        value: 'ledger_entries'
    },
    {
        title: $t('Depreciation entries'),
        value: 'depreciation_entries'
    },
    {
        title: $t('Entry lines count'),
        value: 'entry_lines'
    },
    {
        title: $t('Transaction create'),
        value: 'TRANSACTION_CREATE'
    },
    {
        title: $t('Transaction update'),
        value: 'TRANSACTION_UPDATE'
    },
    {
        title: $t('Purchase invoice create'),
        value: 'PURCHASE_INVOICE_CREATE'
    },
    {
        title: $t('Purchase invoice update'),
        value: 'PURCHASE_INVOICE_UPDATE'
    },
    {
        title: $t('Sales invoice create'),
        value: 'SALES_INVOICE_CREATE'
    },
    {
        title: $t('Sales invoice update'),
        value: 'SALES_INVOICE_UPDATE'
    },
    {
        title: $t('Financial entry create'),
        value: 'FINANCIAL_ENTRY_CREATE'
    },
    {
        title: $t('Financial entry update'),
        value: 'FINANCIAL_ENTRY_UPDATE'
    },
    {
        title: $t('Expense row create'),
        value: 'EXPENSE_ROW_CREATE',
    },
    {
        title: $t('Expense row update'),
        value: 'EXPENSE_ROW_UPDATE'
    },
    {
        title: $t('Depreciation create'),
        value: 'DEPRECIATION_CREATE'
    },
    {
        title: $t('Depreciation update'),
        value: 'DEPRECIATION_UPDATE'
    },
    {
        title: $t('Person count'),
        value: 'PERSON_COUNT'
    },
    {
        title: $t('Fixed assets'),
        value: 'FIXED_ASSETS'
    }
]

export const EMAIL_CUSTOM_SENDERS = [
    {
        name: $t('Company owner'),
        id: 'company_owner'
    },
    {
        name: $t('Primary user'),
        id: 'primary_user'
    }
]

export const TASK_INFO_TABS = () => ({
    ACTIVITY: {
        name: $t('Activity'),
        value: 'activity'
    },
    COMMUNICATION: {
        name: $t('Communication'),
        value: 'communication'
    }
})

export const TASK_INFO_SORT_BY = () => ({
    OLDEST: {
        name: $t('Oldest first'),
        value: 'oldest'
    },
    NEWEST: {
        name: $t('Newest first'),
        value: 'newest'
    }
})

export const EMAIL_AUTOMATION_PLACEHOLDER_TYPES = {
    CLIENT: "client",
    TASK: "task",
    PROJECT: "project",
    CONTACT: "contact",
    TEMPLATE_SIGNATURE: "template_signature", // person default, company default, company signatures
    SIGNATURE: "signature", // person default, company default, person signatures, company signatures
    MEMBER: "member",
    TASK_TITLE: "task_title"
}

export const BILLABLE_FILTERS = [
    {
        text: $t('All'),
        value: 'all'
    },
    {
        text: $t('Billable'),
        value: 'billable'
    },
    {
        text: $t('Non-billable'),
        value: 'not_billable'
    }
]

export const productNamePlaceholders = [
    {
        text: $t('Invoice previous period'),
        value: '{{invoice_previous_period}}'
    },
    {
        text: $t('Invoice period'),
        value: '{{invoice_period}}'
    },
    {
        text: $t('Invoice next period'),
        value: '{{invoice_next_period}}'
    },
    {
        text: $t('Client primary user'),
        value: '{{client_primary_user}}'
    },
    {
        text: $t('Quantity as time'),
        value: '{{quantity_as_time}}'
    },
    {
        text: $t('Quantity as number'),
        value: '{{quantity_as_number}}'
    },
    {
        text: $t('Quantity as time in number format'),
        value: '{{quantity_as_time_as_number}}'
    },
    {
        text: $t('Original client name'),
        value: '{{original_client_name}}'
    },
]

export const HELP_LINKS = {
    APP_MERIT_KEYS: 'app_merit_keys',
    MERIT_SUCCESS_PRIMARY_USER: 'merit_success_primary_user',
    MERIT_SUCCESS_TASK_PLAN: 'merit_success_task_plan',
    MERIT_SUCCESS_AUTOMATIC_MONTHLY_SUMMARY: 'merit_success_automatic_monthly_summary',
    IMPORTER_STEP1: 'importer_step1',
    IMPORTER_STEP2: 'importer_step2',
    IMPORTER_STEP3: 'importer_step3',
    IMPORTER_STEP3_XLSX: 'importer_step3_xlsx',
    IMPORTER_STEP3_MERIT_AKTIVA: 'importer_step3_merit_aktiva',
    IMPORTER_STEP3_ECONOMIC: 'importer_step3_economic',
    EDIT_PLAN: 'edit_plan',
    HELP_MAINMENU: 'help_mainmenu',
    EDIT_MONITORING: 'edit_monitoring',
    SETUP_INTEGRATION: 'setup_integration',
    TASK_FEATURES: 'task_features',
    SETTINGS_BILLING: 'settings_billing',
    SIGNUP_TERMS: 'signup_terms',
    SIGNUP_HELP: 'signup_help',
    ADD_TEMPLATE: 'add_template',
    STORE_PRO_PACKAGE_INFO: 'store_pro_package_info',
    COMPARE_BUNDLES: 'compare_bundles',
    APP_MAGIC_BUTTON: 'app_magic_button',
    CONTRACT_TEMPLATE: 'contract_template',
    APP_EMAILING: 'app_emailing',
    APP_ECONOMIC: 'app_economic',
    EMPLOYMENT_FUND: 'employment_fund'
}

export const roundingOptions = (showCompanyDefault, showClientDefault) => {
    const text = showClientDefault ? $t('Client default') : (showCompanyDefault ? $t('Company default') : "")
    const showDefault = text ? {text: text, value: null} : null
    return [
        showDefault,
        {text: $t("No rounding"), value: 0},
        {text: "1 " + $t("min"), value: 60},
        {text: "5 " + $t("min"), value: 300},
        {text: "10 " + $t("min"), value: 600},
        {text: "15 " + $t("min"), value: 900},
        {text: "20 " + $t("min"), value: 1200},
        {text: "25 " + $t("min"), value: 1500},
        {text: "30 " + $t("min"), value: 1800},
        {text: "45 " + $t("min"), value: 2700},
        {text: "1 " + $t("hour"), value: 3600}
    ].filter(x => x)
}

export const invoiceDatePeriodOptions = (showCompanyDefault, showClientDefault) => {
    const text = showClientDefault ? $t('Client default') : (showCompanyDefault ? $t('Company default') : "")
    const showDefault = text ? {text: text, value: null} : null
    let options = [
        showDefault,
        {text: $t("Last day of month"), value: -1},
        {text: $t("Creation date"), value: 0}
    ].filter(x => x)

    for (let i = 1; i < 29; i++) {
        options.push({text: i.toString(), value: i})
    }
    return options
}

export const yesNoOptions = (showCompanyDefault, showClientDefault) => {
    const text = showClientDefault ? $t('Client default') : (showCompanyDefault ? $t('Company default') : "")
    const showDefault = text ? {text: text, value: null} : null
    return [
        showDefault,
        {text: $t("Yes"), value: 1},
        {text: $t("No"), value: 0}
    ].filter(x => x)
}

export const invoiceRoundByOptions = (showCompanyDefault, showClientDefault) => {
    const text = showClientDefault ? $t('Client default') : (showCompanyDefault ? $t('Company default') : "")
    const showDefault = text ? {text: text, value: null} : null
    return [
        showDefault,
        {text: $t('Invoice line'), value: 'round_by_line'},
        {text: $t('Task time total (per member)'), value: 'round_by_task'}
    ].filter(x => x)
}

export const billByTimeOptions = (showCompanyDefault, showClientDefault) => {
    const text = showClientDefault ? $t('Client default') : (showCompanyDefault ? $t('Company default') : "")
    const showDefault = text ? {text: text, value: null} : null
    return [
        showDefault,
        {text: $t('Time entry'), value: 'time_start'},
        {text: $t('Task due date'), value: 'task_due'},
        {text: $t('Task finish date'), value: 'task_finish'}
    ].filter(x => x)
}

export const billByFieldOptions = (showCompanyDefault, showClientDefault) => {
    const text = showClientDefault ? $t('Client default') : (showCompanyDefault ? $t('Company default') : "")
    const showDefault = text ? {text: text, value: null} : null
    return [
        showDefault,
        {text: $t('Task start date'), value: 'task_start'},
        {text: $t('Task due date'), value: 'task_due'},
        {text: $t('Task finish date'), value: 'task_finish'}
    ].filter(x => x)
}
export const mergePeriodInvoicesOptions = (showCompanyDefault, showClientDefault) => {
    const text = showClientDefault ? $t('Client default') : (showCompanyDefault ? $t('Company default') : "")
    const showDefault = text ? {text: text, value: null} : null
    return [
        showDefault,
        {text: $t('Create separately'), value: 0},
        {text: $t('Merge into one'), value: 1},
    ].filter(x => x)
}
export const currencyOptions = (showCompanyDefault) => {
    const text = showCompanyDefault ? $t('Company default') : ""
    const currencyOptions = [
        {text: "EUR", value: "EUR"},
        {text: "GBP", value: "GBP"},
        {text: "USD", value: "USD"},
        {text: "CAD", value: "CAD"},
        {text: "AUD", value: "AUD"},
        {text: "PLN", value: "PLN"},
        {text: "SEK", value: "SEK"},
        {text: "NOK", value: "NOK"},
        {text: "DKK", value: "DKK"},
        {text: "KZT", value: "KZT"},
        {text: "BGN", value: "BGN"},
        {text: "INR", value: "INR"},
        {text: "ALL", value: "ALL"},
        {text: "AED", value: "AED"},
        {text: "ZAR", value: "ZAR"},
        {text: "BRL", value: "BRL"},
        {text: "RON", value: "RON"},
        {text: "GIP", value: "GIP"},
        {text: "HKD", value: "HKD"},
        {text: "TRY", value: "TRY"},
        {text: "ILS", value: "ILS"},
    ]
    if (text) currencyOptions.unshift(text)
    currencyOptions.sort((a, b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0))
    return currencyOptions.filter(x => x)
}

export const minTimeOptions = (showCompanyDefault) => {
    const text = showCompanyDefault ? $t('Company default') : ""
    const showDefault = text ? {text: text, value: null} : null
    return [
        showDefault,
        {text: $t("No minimum"), value: 0},
        {text: $t("{0} minute").format(1), value: 60},
        {text: $t("{0} minutes").format(5), value: 300},
        {text: $t("{0} minutes").format(10), value: 600},
        {text: $t("{0} minutes").format(15), value: 900},
        {text: $t("{0} minutes").format(20), value: 1200},
        {text: $t("{0} minutes").format(30), value: 1800},
        {text: $t("{0} minutes").format(45), value: 2700},
        {text: $t("{0} hour").format(1), value: 3600},
        {text: $t("{0} hours").format(2), value: 3600 * 2},
        {text: $t("{0} hours").format(3), value: 3600 * 3},
        {text: $t("{0} hours").format(4), value: 3600 * 4},
        {text: $t("{0} hours").format(5), value: 3600 * 5},
        {text: $t("{0} hours").format(6), value: 3600 * 6},
        {text: $t("{0} hours").format(7), value: 3600 * 7},
        {text: $t("{0} hours").format(8), value: 3600 * 8},
        {text: $t("{0} hours").format(9), value: 3600 * 9},
        {text: $t("{0} hours").format(10), value: 3600 * 10},
        {text: $t("{0} hours").format(11), value: 3600 * 11},
        {text: $t("{0} hours").format(12), value: 3600 * 12},
        {text: $t("{0} hours").format(13), value: 3600 * 13},
        {text: $t("{0} hours").format(14), value: 3600 * 14},
        {text: $t("{0} hours").format(15), value: 3600 * 15},
        {text: $t("{0} hours").format(16), value: 3600 * 16},
        {text: $t("{0} hours").format(17), value: 3600 * 17},
        {text: $t("{0} hours").format(18), value: 3600 * 18},
        {text: $t("{0} hours").format(19), value: 3600 * 19},
        {text: $t("{0} hours").format(20), value: 3600 * 20},
        {text: $t("{0} hours").format(21), value: 3600 * 21},
        {text: $t("{0} hours").format(22), value: 3600 * 22},
        {text: $t("{0} hours").format(23), value: 3600 * 23},
        {text: $t("{0} hours").format(24), value: 3600 * 24},
    ]
}

export const REFERRAL_STATUS = {
    INVITED: 'invited',
    REGISTERED: 'registered',
    EARNED: 'earned',
    PAID: 'paid'
}